import Image from "next/image";
import styles from "./dr-saeed.module.scss";
import MobileIcon from "@mui/icons-material/MobileFriendly";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

export default function DrSaeed() {
  return (
    <div className={`${styles["drSaeed"]}`}>
      <div className={`${styles["drSaeedContainer"]}`}>
        <div className={`${styles["drSaeedTop"]}`}>
          <div className={`${styles["drSaeedTopLeft"]}`}>
            <Image
              src="/images/dr-saeed/dubai-gov.jpg"
              alt="Dr Saeed"
              width={192}
              height={80}
            />
          </div>
          <div className={`${styles["drSaeedTopRight"]}`}>
            <Image
              src="/images/dr-saeed/dubai-police-logo.png"
              alt="Dr Saeed"
              width={140}
              height={53}
            />
          </div>
        </div>
      </div>
      <div className={`${styles["drSaeedMiddle"]}`}>
        <div className={`${styles["drSaeedContainer"]}`}>
          <div
            className={`${styles["drSaeedMiddleItem"]} ${styles["drSaeedMiddleItemName"]}`}
          >
            <h2>اللواء / سيف مهير المزروعي</h2>
            <h2>Maj. Gen. Saif Muhair Al Mazrouei</h2>
            <div className={`${styles["drSaeedMiddleItemNameLine"]}`}></div>
          </div>

          <div
            className={`${styles["drSaeedMiddleItem"]} ${styles["drSaeedMiddleItemPosition"]}`}
          >
            <h2>مساعد القائد العام لشؤون العمليات</h2>
            <h2>Assistant Commander-in-Chief for Operations</h2>
          </div>

          <div
            className={`${styles["drSaeedMiddleItem"]} ${styles["drSaeedMiddleItemContact"]}`}
          >
            <a href="tel:00971506547878">
              <MobileIcon />
            </a>
            <a href="mailto:s.mazrouei@dubaipolice.gov.ae">
              <EmailOutlinedIcon />
            </a>
          </div>
          <div className={`${styles["drSaeedMiddleSaveToContact"]}`}>
            <a href="/gen-saif/gen-saif-ar.vcf" target="_blank">
              إضافة إلى دليل الهاتف
            </a>
            <a href="/gen-saif/gen-saif-en.vcf" target="_blank">
              SAVE TO CONTACTS
            </a>
          </div>
        </div>
      </div>
      <div className={`${styles["drSaeedBottom"]}`}>
        <p>
          POWERED BY{" "}
          <a href="/en" target="_blank" rel="noopener">
            <strong>QRHUB.IO</strong>{" "}
          </a>
          AND{" "}
          <a href="https://www.effective.ae" target="_blank" rel="noopener">
            <strong>EFFECTIVE AGENCY</strong>{" "}
          </a>
          COMPANY
        </p>
      </div>
    </div>
  );
}

DrSaeed.hideLayout = true;
